import { render, staticRenderFns } from "./PageDisable.vue?vue&type=template&id=dc3f6808&scoped=true&"
import script from "./PageDisable.vue?vue&type=script&lang=js&"
export * from "./PageDisable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3f6808",
  null
  
)

export default component.exports